import { parameterTypeLabel } from "@/frontend/utils/parameterTypeLabel";
import { Parameter } from "@/backend/models/parameter";
import { Form } from "react-bootstrap";

export function ParameterTypeLabel(props: { parameter: Parameter }) {
  const { parameter } = props;
  return <small className='text-uppercase text-muted' >{`${parameterTypeLabel(parameter)}`}</small>;
}

export function ParameterTitle(props: { parameter: Parameter }) {
  const { parameter } = props;
  return <Form.Label className="col-form-label col-form-label-sm">{parameter.title} <ParameterTypeLabel parameter={parameter} /></Form.Label>;
}
